import React from "react";
import ReactDOM from "react-dom";
import close from "assets/images/close.svg";

const Modal = (props) => {
  return props.show
    ? ReactDOM.createPortal(
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show d-block"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
            onClick={props.close}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ maxWidth: 975, maxHeight: 800, position: "relative" }}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{ position: "relative" }}
              >
                <div
                  data-dismiss="modal"
                  aria-label="Close"
                  style={{
                    position: "absolute",
                    top: 20,
                    right: 25,
                    zIndex: 10,
                  }}
                  onClick={props.close}
                >
                  <img src={close} alt="close" />
                </div>
                {props.children}
              </div>
            </div>
          </div>
        </>,
        document.body
      )
    : null;
};

export default Modal;
